import Modal from 'antd/lib/modal/Modal';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Apis from '../../../../api';
import HSButton from '../../../common/Button';
import MessageActions from '../../../message/redux/actions';
import DealActions from '../redux/actions';

type Props = {
    open: boolean;
    UUID: string;
};

const fundPoints = [
    'This Fund is managed by Helicap Investments Pte Ltd ("HIPL"), a related entity to Helicap Securities Pte Ltd ("HSPL")',
    'A representative from HIPL will contact you to address queries and complete the required documentation, should you raise any interest in the Fund',
    'The respective representatives from HSPL and HIPL will clearly identify themselves when communicating with you',
    'The Fund may invest in the securities that are offered on the platform as a standalone investment opportunity on the platform',
];

const FundDealModel: React.FC<Props> = ({ open, UUID }) => {
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);

    const onClickCancel = () => {};

    const onClickConfirm = () => {
        setLoading(true);
        Apis.dealDisclosureConfirm(UUID)
            .then(() => {
                dispatch(DealActions.setDisclosure(false));
            })
            .catch((err) => {
                dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <Modal
            open={open}
            closeIcon={null}
            title="Disclosure"
            footer={null}
            onCancel={onClickCancel}
            onOk={onClickCancel}
            closable={false}
            width={800}
            centered
            className="fundDisclosure"
        >
            <div className="overflow-auto pr-2 md:pr-0" style={{ maxHeight: 'calc(100vh - 250px)' }}>
                <p className="text-base" style={{ paddingBottom: '0.5rem' }}>
                    Please take note of the following disclosures regarding the offering of the following Fund on the
                    platform:{' '}
                </p>
                <div>
                    <ul className="list-disc pl-5 pb-2">
                        {fundPoints.map((f, index) => (
                            <li className="text-base" key={`fund_${index}`}>
                                {f}
                            </li>
                        ))}
                    </ul>
                </div>
                <p className="text-base">
                    I hereby acknowledge the above disclosures regarding the offering of the Fund.
                </p>
            </div>
            <div className="flex justify-end py-2 mt-2">
                <HSButton title="Confirm" onClick={onClickConfirm} loading={loading} />
            </div>
        </Modal>
    );
};

export default FundDealModel;
